import { cn } from "@rosette/ts/src/util/cn.js";


export interface DropdownOption {
    value: string;
    label: string;
}


interface DropdownProps {
    id: string;
    className?: string;
    name?: string;
    options: DropdownOption[];
    value: string;
    setValue: (value: string) => void;
    tooltipText?: string;
    disabled?: boolean;
}


export function Dropdown({
    id, className, name, options, value, setValue, tooltipText, disabled,
}: DropdownProps) {
    return (
        <select
            className={cn(
                "appearance-none rounded-sm border border-dropdown bg-dropdown px-4 py-0.5 text-base text-on-dropdown *:p-[10px]",
                "hover:border-dropdown-hover focus:border-focus focus:ring-3 focus:ring-focus/25 focus:outline-none",
                "disabled:border-dropdown disabled:bg-dropdown-disabled disabled:text-on-dropdown-disabled",
                className ?? null,
            )}
            id={id}
            name={name}
            value={value}
            onChange={e => setValue(e.target.value)}
            title={tooltipText}
            disabled={disabled}>

            {options.map(option => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    );
}
